import * as S from './index.style'
import Grid from 'components/Grid'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import { InputBaseComponentProps } from '@material-ui/core/InputBase'
import { ElementType, useState } from 'react'
import { DialogHeader } from 'components/DialogHeader'
import { MascaraInteiro } from 'components/Mascara/Inteiro'
import { DadosTipologia, dadosTipologiaValorDefault, ValidacaoDadosTipologia } from 'models/Viabilidade/Tipologia'
import { CamposTipologiaEnum } from 'models/Viabilidade/Enum/CamposTipologiaEnum'
import { helperTextErroCampoOpcional } from 'helpers/Constantes/Mensagens'

const NovaTipologia: React.FC<{
  dadosTipologia: DadosTipologia
  indiceEdicao: number
  adicionarTipologiaHandler: (novoValor: DadosTipologia) => void
  editarTipologiaHandler: (novoValor: DadosTipologia, indiceEdicao: number) => void
  closeDialogTipologiaHandler: () => void
}> = ({ dadosTipologia, indiceEdicao, adicionarTipologiaHandler, editarTipologiaHandler, closeDialogTipologiaHandler }) => {
  const [valores, setValores] = useState(dadosTipologia)
  const [mensagensErro, setMensagensErro] = useState(new ValidacaoDadosTipologia())
  const [habilitarConfirmar, setHabilitarConfirmar] = useState(false)
  const EhEdicao = dadosTipologia != dadosTipologiaValorDefault

  const inicializarValidacaoCamposPreenchidos = (): boolean[] => {
    if (EhEdicao) {
      return new Array(9).fill(true)
    }
    const validacaoCamposPreenchidos = new Array(9).fill(false)
    validacaoCamposPreenchidos[CamposTipologiaEnum.QuantidadePermutas] = true
    validacaoCamposPreenchidos[CamposTipologiaEnum.AreaServico] = true
    validacaoCamposPreenchidos[CamposTipologiaEnum.PerimetroMuroPorLote] = true
    return validacaoCamposPreenchidos
  }

  const listaTipologias = ['1 Q', '1 Q S', '2 Q', '2 Q COB', '2 Q S', '2 Q S COB', '3 Q S', '3 Q S COB', '4 Q S', '4 Q S COB', '1Q PNE', '2Q PNE', '2Q R']

  const [camposPreenchidos, setCamposPreenchidos] = useState(inicializarValidacaoCamposPreenchidos())

  const replaceState = (event: React.ChangeEvent<HTMLInputElement>): Record<string, unknown> => {
    const state = { ...valores } as Record<string, unknown>
    state[event.target.name] = event.target.value
    return state
  }

  const checkCampoPreenchido = (index: number, novoValor: boolean) => {
    const novoCamposPreenchidos = [...camposPreenchidos]
    novoCamposPreenchidos[index] = novoValor
    setCamposPreenchidos(novoCamposPreenchidos)
    setHabilitarConfirmar(novoCamposPreenchidos.every((item) => item))
  }

  const camposHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosTipologia
    setValores(state)
  }

  const descricaoHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = replaceState(event) as DadosTipologia
    state.descricao = retirarCaracteresEspeciais(state.descricao)
    setValores(state)
  }

  const retirarCaracteresEspeciais = (valor: string): string => {
    return valor.replace(/([^\w\sà-úÀ-Ú-])/gi, '')
  }

  const btnAdicionarTipologiaHandler = () => {
    adicionarTipologiaHandler(valores)
  }

  const btnEditarTipologiaHandler = () => {
    editarTipologiaHandler(valores, indiceEdicao)
  }

  const validarDescricao = () => {
    const erroDescricao = mensagensErro.validarDescricao(valores.descricao.toString())

    checkCampoPreenchido(CamposTipologiaEnum.Descricao, erroDescricao === '')

    const validador = new ValidacaoDadosTipologia(
      erroDescricao,
      mensagensErro.quantidadeUnidades,
      mensagensErro.quantidadePermutas,
      mensagensErro.areaLote,
      mensagensErro.areaCasa,
      mensagensErro.tipologiaCasas,
      mensagensErro.perimetroMuroPorLote,
      mensagensErro.areaServicoExterna,
      mensagensErro.precoTabela
    )

    setMensagensErro(validador)
  }

  const validarQuantidadeUnidades = () => {
    const erroQuantidadeUnidades = mensagensErro.validarQuantidadeUnidades(valores.quantidadeUnidades.toString(), valores.quantidadePermutas.toString())

    checkCampoPreenchido(CamposTipologiaEnum.QuantidadeUnidades, erroQuantidadeUnidades === '')

    const validador = new ValidacaoDadosTipologia(
      mensagensErro.descricao,
      erroQuantidadeUnidades,
      mensagensErro.quantidadePermutas,
      mensagensErro.areaLote,
      mensagensErro.areaCasa,
      mensagensErro.tipologiaCasas,
      mensagensErro.perimetroMuroPorLote,
      mensagensErro.areaServicoExterna,
      mensagensErro.precoTabela
    )

    setMensagensErro(validador)
  }

  const validarQuantidadePermutas = () => {
    const erroQuantidadePermutas = mensagensErro.validarQuantidadePermutas(valores.quantidadePermutas.toString(), valores.quantidadeUnidades.toString())

    checkCampoPreenchido(CamposTipologiaEnum.QuantidadePermutas, erroQuantidadePermutas === '')

    const validador = new ValidacaoDadosTipologia(
      mensagensErro.descricao,
      mensagensErro.quantidadeUnidades,
      erroQuantidadePermutas,
      mensagensErro.areaLote,
      mensagensErro.areaCasa,
      mensagensErro.tipologiaCasas,
      mensagensErro.perimetroMuroPorLote,
      mensagensErro.areaServicoExterna,
      mensagensErro.precoTabela
    )

    setMensagensErro(validador)
  }

  const validarAreaLote = () => {
    const erroAreaLote = mensagensErro.validarInputUsuario(valores.areaLote.toString())

    checkCampoPreenchido(CamposTipologiaEnum.AreaLote, erroAreaLote === '')

    const validador = new ValidacaoDadosTipologia(
      mensagensErro.descricao,
      mensagensErro.quantidadeUnidades,
      mensagensErro.quantidadePermutas,
      erroAreaLote,
      mensagensErro.areaCasa,
      mensagensErro.tipologiaCasas,
      mensagensErro.perimetroMuroPorLote,
      mensagensErro.areaServicoExterna,
      mensagensErro.precoTabela
    )

    setMensagensErro(validador)
  }

  const validarTipologiaCasas = () => {
    const erroTipologiaCasas = mensagensErro.validarInputUsuario(valores.tipologiaCasas as string)

    checkCampoPreenchido(CamposTipologiaEnum.TipologiaCasas, erroTipologiaCasas === '')

    const validador = new ValidacaoDadosTipologia(
      mensagensErro.descricao,
      mensagensErro.quantidadeUnidades,
      mensagensErro.quantidadePermutas,
      mensagensErro.areaLote,
      mensagensErro.areaCasa,
      erroTipologiaCasas,
      mensagensErro.perimetroMuroPorLote,
      mensagensErro.areaServicoExterna,
      mensagensErro.precoTabela
    )

    setMensagensErro(validador)
  }

  const validarAreaCasa = () => {
    const erroAreaCasa = mensagensErro.validarInputUsuario(valores.areaCasa.toString())

    checkCampoPreenchido(CamposTipologiaEnum.AreaCasa, erroAreaCasa === '')

    const validador = new ValidacaoDadosTipologia(
      mensagensErro.descricao,
      mensagensErro.quantidadeUnidades,
      mensagensErro.quantidadePermutas,
      mensagensErro.areaLote,
      erroAreaCasa,
      mensagensErro.tipologiaCasas,
      mensagensErro.perimetroMuroPorLote,
      mensagensErro.areaServicoExterna,
      mensagensErro.precoTabela
    )

    setMensagensErro(validador)
  }

  const validarPerimetroMuroPorLote = () => {
    const erroPerimetroMuroPorLote = mensagensErro.validarCampoMaiorQueZero(valores.perimetroMuroPorLote.toString())

    checkCampoPreenchido(CamposTipologiaEnum.PerimetroMuroPorLote, erroPerimetroMuroPorLote === '')

    const validador = new ValidacaoDadosTipologia(
      mensagensErro.descricao,
      mensagensErro.quantidadeUnidades,
      mensagensErro.quantidadePermutas,
      mensagensErro.areaLote,
      mensagensErro.areaCasa,
      mensagensErro.tipologiaCasas,
      erroPerimetroMuroPorLote,
      mensagensErro.areaServicoExterna,
      mensagensErro.precoTabela
    )

    setMensagensErro(validador)
  }

  const validarAreaServico = () => {
    const erroAreaServico = mensagensErro.validarCampoMaiorQueZero(valores.areaServicoExterna.toString())

    checkCampoPreenchido(CamposTipologiaEnum.AreaServico, erroAreaServico === '')

    const validador = new ValidacaoDadosTipologia(
      mensagensErro.descricao,
      mensagensErro.quantidadeUnidades,
      mensagensErro.quantidadePermutas,
      mensagensErro.areaLote,
      mensagensErro.areaCasa,
      mensagensErro.tipologiaCasas,
      mensagensErro.perimetroMuroPorLote,
      erroAreaServico,
      mensagensErro.precoTabela
    )

    setMensagensErro(validador)
  }

  const validarPrecoTabela = () => {
    const erroPrecoTabela = mensagensErro.validarInputUsuario(valores.precoTabela.toString())

    checkCampoPreenchido(CamposTipologiaEnum.PrecoTabela, erroPrecoTabela === '')

    const validador = new ValidacaoDadosTipologia(
      mensagensErro.descricao,
      mensagensErro.quantidadeUnidades,
      mensagensErro.quantidadePermutas,
      mensagensErro.areaLote,
      mensagensErro.areaCasa,
      mensagensErro.tipologiaCasas,
      mensagensErro.perimetroMuroPorLote,
      mensagensErro.areaServicoExterna,
      erroPrecoTabela
    )

    setMensagensErro(validador)
  }

  return (
    <S.Wrapper data-cy="cardNovaTipologia">
      <DialogHeader titulo={EhEdicao ? 'EDITAR TIPOLOGIA' : 'NOVA TIPOLOGIA'} closedDialog={closeDialogTipologiaHandler} />
      <Grid orientacao="row" gridTemplateColumns="repeat(4,1fr)" gridTemplateRow="1fr" gridGap="32px" margin="0">
        <div>
          <S.Label>Descrição do Produto</S.Label>
          <TextField
            placeholder="Ex.: Tipo 1"
            type="text"
            name="descricao"
            data-cy="campoDescricao"
            variant="outlined"
            size="small"
            onBlur={validarDescricao}
            onChange={descricaoHandler}
            inputProps={{ maxLength: 100 }}
            value={valores.descricao}
            error={mensagensErro.descricao != ''}
            helperText={mensagensErro.descricao}
          />
        </div>
        <div>
          <S.Label>Quantidade de Unidades</S.Label>
          <TextField
            placeholder="000"
            type="text"
            name="quantidadeUnidades"
            data-cy="campoQuantidadeUnidades"
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraInteiro as unknown as ElementType<InputBaseComponentProps>
            }}
            onBlur={validarQuantidadeUnidades}
            onChange={camposHandler}
            value={valores.quantidadeUnidades}
            error={mensagensErro.quantidadeUnidades != ''}
            helperText={mensagensErro.quantidadeUnidades}
          />
        </div>
        <div>
          <S.Label>Quantidade de Permutas</S.Label>
          <TextField
            placeholder="000"
            type="text"
            name="quantidadePermutas"
            data-cy="campoQuantidadePermutas"
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraInteiro as unknown as ElementType<InputBaseComponentProps>
            }}
            onBlur={validarQuantidadePermutas}
            onChange={camposHandler}
            value={valores.quantidadePermutas}
            error={mensagensErro.quantidadePermutas != ''}
            helperText={helperTextErroCampoOpcional(mensagensErro.quantidadePermutas)}
          />
        </div>
        <div>
          <S.Label>Área Lote (m²)</S.Label>
          <TextField
            placeholder="000.000,00"
            type="text"
            name="areaLote"
            data-cy="campoAreaLote"
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            onBlur={validarAreaLote}
            onChange={camposHandler}
            value={valores.areaLote}
            error={mensagensErro.areaLote != ''}
            helperText={mensagensErro.areaLote}
          />
        </div>
      </Grid>
      <Grid orientacao="row" gridTemplateColumns="repeat(4,1fr)" gridTemplateRow="repeat(2,1fr)" gridGap="32px" margin="0">
        <div>
          <S.Label>Tipologia Casas</S.Label>
          <TextField
            name="tipologiaCasas"
            data-cy="campoTipologiaCasas"
            fullWidth
            variant="outlined"
            size="small"
            onBlur={validarTipologiaCasas}
            onChange={camposHandler}
            value={valores.tipologiaCasas}
            error={mensagensErro.tipologiaCasas != ''}
            helperText={mensagensErro.tipologiaCasas}
            select
          >
            {listaTipologias.map((tipologia, index) => (
              <MenuItem key={index} data-cy={`tipologiaCasas_${index}`} value={tipologia}>
                {tipologia}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div>
          <S.Label>Área Casa (m²)</S.Label>
          <TextField
            name="areaCasa"
            data-cy="campoAreaCasa"
            placeholder="000.000,00"
            type="text"
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            onBlur={validarAreaCasa}
            onChange={camposHandler}
            value={valores.areaCasa}
            error={mensagensErro.areaCasa != ''}
            helperText={mensagensErro.areaCasa}
          />
        </div>
        <div>
          <S.Label>Perímetro Muro por Lote (m)</S.Label>
          <TextField
            placeholder="000.000,00"
            type="text"
            name="perimetroMuroPorLote"
            data-cy="campoPerimetroMuroPorLote"
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            onBlur={validarPerimetroMuroPorLote}
            onChange={camposHandler}
            value={valores.perimetroMuroPorLote}
            error={mensagensErro.perimetroMuroPorLote != ''}
            helperText={helperTextErroCampoOpcional(mensagensErro.perimetroMuroPorLote)}
          />
        </div>
        <div>
          <S.Label>Área Serviço (m²)</S.Label>
          <TextField
            placeholder="000.000,00"
            type="text"
            name="areaServicoExterna"
            data-cy="campoAreaServicoExterna"
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            onBlur={validarAreaServico}
            onChange={camposHandler}
            value={valores.areaServicoExterna}
            error={mensagensErro.areaServicoExterna != ''}
            helperText={helperTextErroCampoOpcional(mensagensErro.areaServicoExterna)}
          />
        </div>
        <div>
          <S.Label>Preço Tabela (R$/Unid)</S.Label>
          <TextField
            placeholder="000.000,00"
            type="text"
            name="precoTabela"
            data-cy="campoPrecoTabela"
            variant="outlined"
            size="small"
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            onBlur={validarPrecoTabela}
            onChange={camposHandler}
            value={valores.precoTabela}
            error={mensagensErro.precoTabela != ''}
            helperText={mensagensErro.precoTabela}
          />
        </div>
      </Grid>
      <S.GridBotoes orientacao="column" gridTemplateColumns="repeat(2,20%)" gridTemplateRow="1fr" gridGap="20px" margin="0">
        <div>
          <Button
            data-cy="btnCancelarTipologia"
            onClick={closeDialogTipologiaHandler}
            variant="text"
            style={{ height: '40px', width: '136px', fontSize: '14px' }}
            color="primary"
          >
            Cancelar
          </Button>
        </div>
        <div>
          <Button
            data-cy="btnAdicionarTipologia"
            variant="contained"
            style={{ height: '40px', fontSize: '14px' }}
            onClick={EhEdicao ? btnEditarTipologiaHandler : btnAdicionarTipologiaHandler}
            color="secondary"
            disabled={!habilitarConfirmar}
          >
            {EhEdicao ? 'Salvar Alterações' : 'Adicionar Tipologia'}
          </Button>
        </div>
      </S.GridBotoes>
    </S.Wrapper>
  )
}

export default NovaTipologia
